import Orders from "./Orders";
import UpdateOrders from "./UpdateOrders";
import ViewOrders from "./ViewOrders";

export {
    Orders,
    UpdateOrders,
    ViewOrders,
}